import {
    Box,
    Button,
    Link as ChakraLink,
    Flex,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';

import React from 'react';
import ZendeskWidget from './zendesk-widget';

export default function TopNavigationSupportModal(props) {
    const { useEffect, useState } = React;
    const { onClose, supportModalOpen, setSupportModalOpen, user, company, application, zendeskWidget, translations } = props;
    const [zendeskOpen, setZendeskOpen] = useState(false);
    
    return (
      <>
        {zendeskOpen && (
          <ZendeskWidget user={user} company={company} setZendeskOpen={setZendeskOpen} />
        )}
  
        <Modal
          isOpen={supportModalOpen}
          isCentered
          size="3xl"
          onClose={() => setSupportModalOpen(false)}
        >
          <ModalOverlay />
  
          <ModalContent>
            <ModalCloseButton />
  
            <ModalBody>
              <Flex alignItems="center">
                {company.feature_flags.enable_continu_support && (
                  <Box flex={1} padding={4} textAlign="center">
                    <Image
                      src="/public/images/supportChat.svg"
                      width={100}
                      height={100}
                      margin="0 auto"
                      marginBottom={4}
                    />
  
                    <Text>View the Support Center</Text>
  
                    <ChakraLink
                      href={application.supportCenterBrandLocation}
                      onClick={() => {
                        setSupportModalOpen(false);
                        // onClose();
                      }}
                      isExternal
                    >
                      <Button
                        marginY={4}
                        paddingY={4}
                        paddingX={8}
                        _hover={{
                          backgroundColor: 'brand.tertiary',
                          cursor: 'pointer',
                        }}
                      >
                        Visit Support Center
                      </Button>
                    </ChakraLink>
                  </Box>
                )}
  
                {application && application.ticketingBrand && application.ticketingBrand.customSupport ? (
                  <Box flex={1} padding={10} textAlign="center">
                    <Image
                      src="/public/images/supportBook.svg"
                      width={100}
                      height={100}
                      margin="0 auto"
                      marginBottom={4}
                    />
  
                    <Text>{translations.supportMenuCaption}</Text>
  
                    <ChakraLink
                      href={application.ticketingBrand.location}
                      onClick={() => {
                        setSupportModalOpen(false);
                        onClose();
                      }}
                      isExternal
                    >
                      <Button
                        marginY={4}
                        paddingY={4}
                        paddingX={8}
                        _hover={{
                          backgroundColor: 'brand.tertiary',
                          cursor: 'pointer',
                        }}  
                      >
                        {translations.supportMenuLink}
                      </Button>
                    </ChakraLink>
                  </Box>
                ) : (
                  <Box flex={1} padding={10} textAlign="center">
                    <Image
                      src="/public/images/supportBook.svg"
                      width={100}
                      height={100}
                      margin="0 auto"
                      marginBottom={4}
                    />
  
                    <Text>Contact Our Support Team</Text>
  
                    <Button
                      marginY={4}
                      paddingY={4}
                      paddingX={8}
                      _hover={{
                        backgroundColor: 'brand.tertiary',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setSupportModalOpen(false);
                        // onClose();
                        
                        zendeskWidget.load(() => zendeskWidget.display())
                      }}
                    
                    >
                      Open a Ticket
                    </Button>
                  </Box>
                )}
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    );
  }
  